import { useEffect, useRef, useState } from "react";
import { fileExists } from "./ActividadesUtils/ActividadesUtils";
import { Trans } from "react-i18next";
import { useContext } from "react";
import { ActividadContext } from "./ActividadesUtils/ActWrapper";

function PracticariosPlayer({ interactivo, instrucciones }) {
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const [availableFile, setAvailableFile] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const activityContext = useContext(ActividadContext);

  const path_origin = "https://storage.googleapis.com/nimbus-interactivos/practicarios-matematicas/";
  const targetOrigin = (() => {
    try {
      return new URL(path_origin).origin; 
    } catch (e) {
      return "*";
    }
  })();

  useEffect(() => {
    setAvailableFile(fileExists());
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  const fileName = interactivo.split("?")[0].split("/").pop();
  const id_html = "html_" + fileName;
  
  const pathWithoutPrefix = interactivo.split("/").slice(1).join("/");
  const iframeSrc = path_origin + pathWithoutPrefix;
  //console.log("iframeSrc", iframeSrc);

  useEffect(() => {
    function onMessage(event) {
      if (targetOrigin !== "*" && event.origin !== targetOrigin) return;

      let data = event.data;
      try {
        data = typeof data === "string" ? JSON.parse(data) : data;
      } catch (e) {
        console.error("[PracticariosPlayer] Error procesando mensaje:", e);
        return;
      }

      console.log("[PracticariosPlayer host] message:", data);

      if (data && data.type === "math-global-progress") {
        console.log("[PracticariosPlayer host] global progress:", data.data);
      }

      if (data && data.type === "math-current-score") {
        console.log(
          "[PracticariosPlayer host] current score:",
          data.calificacion,
          data,
        );
      }

      if (data && data.actividad && data.calificacion !== undefined) {
        activityContext.postCalificacionActividad(data.calificacion * 10);
      }
    }

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [targetOrigin, activityContext]);

  return (
    <div className="relative w-full">
      {instrucciones && (
        <div className="act-instructions mb-6">{instrucciones}</div>
      )}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0 text-nimbusLight font-bold text-lg max-w-[500px] mt-10">
        {!availableFile && (
          <div className="text-center font-bold text-nimbusLight !text-base p-2">
            <Trans i18nKey={"resourceNotFound"}></Trans>
          </div>
        )}
      </div>
        <div
          ref={containerRef}
          className={`relative ${isFullscreen ? "w-full h-full flex items-center justify-center" : ""}`}
          style={isFullscreen ? { backgroundColor: "#f8fcff" } : {}}
        >
          <iframe
            ref={iframeRef}
            className={isFullscreen ? "w-full h-full" : "relative w-full mx-auto aspect-video my-[50px] z-10"}
            src={iframeSrc}
            title="activity-frame"
            id={id_html}
            allowFullScreen
          />
          <button
            onClick={toggleFullscreen}
            title={isFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}
            className="absolute bottom-4 right-4 z-20 bg-nimbus text-white rounded-md p-2 hover:bg-nimbusLight transition-colors"
          >
            {isFullscreen ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 9V4H4v5h5zm6 0h5V4h-5v5zm-6 6H4v5h5v-5zm6 0v5h5v-5h-5z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4h4M16 4h4v4M4 16v4h4m8 0h4v-4" />
              </svg>
            )}
          </button>
        </div>
    </div>
  );
}

export default PracticariosPlayer;